import { InfoCard as InfoCard$2, InfoCardContainer, InfoCardThumbnail, InfoCardBody, InfoCardHeader, InfoCardContent } from './style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var InfoCard = function InfoCard(_ref) {
  var $markerSelected = _ref.$markerSelected,
    $position = _ref.$position,
    children = _ref.children,
    className = _ref.className,
    header = _ref.header,
    hidden = _ref.hidden,
    thumbnail = _ref.thumbnail;
  return /*#__PURE__*/jsx(InfoCard$2, {
    $markerSelected: $markerSelected,
    $position: $position,
    className: className,
    $isHidden: hidden,
    children: /*#__PURE__*/jsxs(InfoCardContainer, {
      children: [thumbnail ? /*#__PURE__*/jsx(InfoCardThumbnail, {
        children: /*#__PURE__*/jsx("img", {
          className: "sg-infocard__thumbnail",
          loading: thumbnail.lazy ? 'lazy' : 'eager',
          src: thumbnail.src,
          alt: thumbnail.alt,
          role: thumbnail.alt ? null : 'presentation'
        })
      }) : null, /*#__PURE__*/jsxs(InfoCardBody, {
        children: [/*#__PURE__*/jsx(InfoCardHeader, {
          children: header
        }), /*#__PURE__*/jsx(InfoCardContent, {
          children: children
        })]
      })]
    })
  });
};
InfoCard.defaultProps = {
  $markerSelected: false,
  $position: 'top-center',
  children: undefined,
  className: undefined,
  header: undefined,
  hidden: false,
  thumbnail: undefined
};
var InfoCard$1 = InfoCard;

export { InfoCard$1 as default };
//# sourceMappingURL=InfoCard.js.map
